import { writable, derived } from 'svelte/store';
const UserKey = 'aj-user';
export const user = writable(sessionStorage.getItem(UserKey));
export const login = (newUser) => {
    sessionStorage.setItem(UserKey, newUser);
    user.set(newUser);
};
export const isAuthenticated = derived(user, $user => !!$user);
